enum EVideoRendererSourceProvider {
    Vimeo = "vimeo"
}

export { EVideoRendererSourceProvider }
